module.exports = __webpack_public_path__ + "static/media/healthy-life-meditation-peace-svgrepo-com.fb72e8fc.svg";